import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate } from "react-router";
import { Plus, X, Edit2, Trash2, Save} from 'lucide-react';
import axios from 'axios';
import api from './Services';
import moonIcons from './assets/moonIcons'
import getMoonPhase from './Utilities/getMoonPhase.js'
import getMoonZodiac from './Utilities/getMoonZodiac.js'
import getZodiacColor from './Utilities/getZodiacColor.js'
import WeatherIcon from './Components/WeatherIcon'
import PhaseIcon from './Components/PhaseIcon'
import SeasonIcon from './Components/SeasonIcon'
import SelectVegetables from './Components/SelectVegetables';

export default function Calendar(props) {
  const navigate = useNavigate();
  const [today, setToday] = useState(new Date());
  const [currentDate, setCurrentDate] = useState(today);
  const [weatherForecastData, setWeatherForecastData] = useState({data:[], isLoading:false, error:null});
  //const [selectedDate, setSelectedDate] = useState(null);
  const [showEntryModal, setShowEntryModal] = useState(false);
  const [editingEntry, setEditingEntry] = useState(null);
  const initialFormData = {id: null, date: currentDate, title: '', description: '', entry_type: 'select', vegetable_name: '', vegetableID: null }
  const [formData, setFormData] = useState(initialFormData);
  const [calendarEntries, setCalendarEntries] = useState([]);

  const monthNames = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
  ];
  

/*====================== 

  // KEEP "TODAY" UP TO DATE
  ============================*/

  useEffect(() => {
    setTimeout(updateClock, 60000 )
  }, [today]);

  const updateClock = () => {
    setToday(new Date())

  }



console.log('currentDate', currentDate, 'today', today)

/*====================== 

  // FETCH CALENDAR ENTRIES
  ============================*/


  useEffect(() => {
    fetchCalendarEntries()
  }, [currentDate]);
  const fetchCalendarEntries = async () => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1;

         api
            .get(`/wp-json/mooncal/v1/calendar-entry?year=${year}&month=${month.toString().padStart(2, '0')}`)
            .then((response) => {
              setCalendarEntries(response.data.data)
            })
            .catch((err) => {
                console.log(err.message);
            });
  };




  
  /*====================== 
  FETCH Weather Forecast
  ============================*/


  useEffect(() => {
    setWeatherForecastData({...weatherForecastData, isLoading:true})
    const fetchWeatherForecastData = async () => {
         axios
            .get('https://api.weather.gov/gridpoints/ALY/69,29/forecast')
            .then((response) => {
            addLowTemptoDaytime(response.data.properties.periods)
            })
            .catch((err) => {
                console.log(err.message);
            });          
    }
    fetchWeatherForecastData()
 }, []);
  


  /*====================== 
  FORMAT WEATHER ARRAY
  ============================*/


    // Add low temperatures to the isDaytime periods

    const addLowTemptoDaytime = (periods) => {
      let newArr = []
      let daytimeObj = {}
      let firstIsNightime = true
      periods.map((period) => {
        if (!period.isDaytime && firstIsNightime) {
          firstIsNightime = false
          return newArr.push(period)
        }
        if (period.isDaytime) {
          daytimeObj = period
          firstIsNightime = false
        }else {
          daytimeObj.lowTemperature = period.temperature
          newArr.push(daytimeObj)
        }
      })
      setWeatherForecastData({ data: newArr, isLoading: false, error: null });
    
    }



  /*====================== 
   POST / PUT
  ============================*/
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    const curVeg = (formData.vegetableID) ? props.vegetables.find((veg) => veg.id === formData.vegetableID[0]) : ''

    if (!formData.date) return;
    const moonData = getMoonPhase(new Date(formData.date));
    const zodiac = getMoonZodiac(new Date(formData.date));
    //const currentDate = formData.date;
    //const year = currentDate.getFullYear();
    //const month = ('0' + (currentDate.getMonth() + 1)).slice(-2);
    //const day = ('0' + currentDate.getDate()).slice(-2);
    //const formattedDate = year + month + day;

    const entryData = {
      title: (formData.entry_type === 'sowing_date') ? 'Sow ' + curVeg.title.rendered : formData.title ,
      status: 'publish',
      acf: {
        entry_date: formData.date,
        description: formData.description,
        entry_type: formData.entry_type,
        moon_phase: moonData.phaseName,
        zodiac_sign: zodiac.name,
      }
    }

    if (formData.vegetableID) {
       entryData.acf.vegetable = formData.vegetableID
    }

      if (editingEntry) {
        api
            .put(`/wp-json/wp/v2/calendar-entry/${formData.id}`, entryData)
            .then((response) => {
              fetchCalendarEntries()
              setFormData(initialFormData)
              closeEntryModal();
             })
            .catch((err) => {
                console.log(err.message);
                if (err.status === 400) {
                  navigate('/login')
                }
            });

      } else {
        api
            .post('/wp-json/wp/v2/calendar-entry', entryData)
            .then((response) => {
              fetchCalendarEntries()
              setFormData(initialFormData)
              closeEntryModal();
             })
            .catch((err) => {
                console.log(err.message);
                if (err.status === 400) {
                  navigate('/login')
                }
            });
      }
  };


  /*====================== 
   DELETE
  ============================*/


  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this entry?')) return;
    
        api
            .delete(`/wp-json/wp/v2/calendar-entry/${id}`)
            .then((response) => {
              fetchCalendarEntries()
             })
            .catch((err) => {
                console.log(err.message);
                if (err.status === 400) {
                  navigate('/login')
                }
            });

  };



  /*====================== 
  HANDLE EDIT
  ============================*/

  const handleEdit = (entry, date) => {
    //setSelectedDate(date);
    setEditingEntry(entry);
    setFormData({
      id: entry.id,
      date: date,
      title: entry.title,
      description: entry.description || '',
      entry_type: entry.entry_type,
      vegetable_name: entry.vegetable_name,
      vegetableID: entry.vegetableID
    });
    setShowEntryModal(true);
  };
  






  /*====================== 
  RENDER WEATHER ENTRIES
  ============================*/


// If the first entry is Night !isDaytime, show it, otherwise just show daytime periods
   const weatherEntries = weatherForecastData.data.map( entry => 
      <div key={entry.number} className="w-40 text-white text-xs text-center">
        <div className="mb-2 font-bold text-sm hidden sm:block">{entry.name}</div>
        <div className="mb-2 font-bold text-sm block sm:hidden">{new Date(entry.startTime).toLocaleDateString('en-US', { weekday: 'short' })}</div>
        <div className="mb-1 mx-auto w-14 sm:w-20 flex justify-center">
        <WeatherIcon entry={entry} />    
        </div>
        <div className="text-lg">{entry.temperature}°{ entry.isDaytime && <span className="hidden sm:inline">/</span>}
          <span className="text-xs block sm:inline">{ entry.isDaytime && entry.lowTemperature + '°'}</span>
        </div> 
        
        <div className="hidden sm:block">{entry.shortForecast}</div>
      </div>
    )



  /*====================== 
  GET WEATHER DATA BY DATE
  ============================*/

   const getDayWeatherData = (date) => {
    const calendarDate = date.toISOString().split('T')[0]

    const foundForecastData = weatherForecastData.data.find((forecastData) => forecastData.startTime.split('T')[0] === calendarDate);
    if (foundForecastData) {
      return {temperature: foundForecastData.temperature, lowTemperature: foundForecastData.lowTemperature}
    }
   }



  /*====================== 
  CREATE CALENDAR DAYS
  ============================*/

// Create calendar days  
  const calendarDays = useMemo(() => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const startingDayOfWeek = firstDay.getDay();
    const days = [];
    const phases = []
    for (let i = 0; i < startingDayOfWeek; i++) {
      days.push(null);
    }
    
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month, day, '12', '00', '00');
      const moonData = getMoonPhase(date);
      const zodiac = getMoonZodiac(date);
      const weatherData = getDayWeatherData(date);
      // Get entries for this date
      const dateStr = date.toISOString().split('T')[0];
      const dayEntries = calendarEntries.filter(e => e.date.split('T')[0] === dateStr);

      const dayName = new Date(year,month,day).toLocaleString('en-us', {  weekday: 'short' })

      days.push({
        date: day,
        dayName: dayName,
        fullDate: dateStr,
        //moonPhase: moonData.phase,
        //majorPhase: moonData.majorPhase,
        phaseIcon: <PhaseIcon key={`empty-${day}`} phase={moonData.phase} date={date} currentDate={currentDate} width='4' height='4'  />,
        seasonIcon: <SeasonIcon key={`emptySeason-${day}`} currentDate={currentDate} date={date} />,
        zodiac: zodiac,
        weatherData: weatherData,
        entries: dayEntries
      });

      phases.push(moonData.phase)
    }

    return days;  
  }, [currentDate, calendarEntries, weatherForecastData]);
  



  /*====================== 
  GET ZODIAC INDICATOR
  ============================*/

  const getZodiacIndicator = (zodiac) => {
    const degreeInSign = zodiac.degreeInSign 

    if (degreeInSign < 4) {
      const percentInSign = (4 - degreeInSign) * 6.25
      return <div style={ {width: `${percentInSign}% `} } className={`${getZodiacColor(zodiac, true, false)} absolute block h-3 bottom-[-1%] left-0 z-10 rounded-bl-xl`}></div>
    }

    else if (degreeInSign > 20) {
      const percentInSign = (20 - degreeInSign) * -(7.5)
      return <div style={ {width: `${percentInSign}% `} } className={`${getZodiacColor(zodiac, false, true)} absolute block h-3 bottom-[-1%] right-0 z-10 rounded-br-xl`}></div>
    }

    else return null
  }




  /*====================== 
  MONTH NAV
  ============================*/

  const prevMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1, today.getHours(), today.getMinutes(), today.getSeconds() ));
  };
  
  const nextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1, today.getHours(), today.getMinutes(), today.getSeconds() ));
  };

 const thisMonth = () => {
    setCurrentDate(today);
  };

  const jumpToToday = (e) => {
    e.preventDefault();
    document.getElementById('today')?.scrollIntoView({ block: "center", behavior: 'smooth' })

  }

  
  /*====================== 
  MODAL
  ============================*/

  // Add new Entry
  const openEntryModal = (date) => {
    //setSelectedDate(date);
    setShowEntryModal(true);
    setEditingEntry(null);
    setFormData({...formData, date: date});
  };
  
  const closeEntryModal = () => {
    setShowEntryModal(false);
    //setSelectedDate(null);
    setEditingEntry(null);
    setFormData(initialFormData);
  };



  return (

    <>  


    {props.vegetables.length === 0 || weatherForecastData.isLoading || calendarEntries.length === 0 ? (
      <div>
        <div className="w-full h-screen grid place-content-center bg-purple-500">
            <div className="animate-spin w-20 h-20" role="status">
                <svg dataname="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22">
                  <circle cx="11" cy="11" r="11"/>
                  <path className="fill-orange-400" d="M18,11c0,5.52-3.13,10-7,10,5.52,0,10-4.48,10-10S16.52,1,11,1c3.87,0,7,4.48,7,10Z"/>
                </svg>               
                <span className="sr-only">Loading...</span>
            </div>
        </div>

      </div>
    )
    :(
      <>

        {/* Weather */}
          <div className="overflow-x-auto">
            <div className="flex justify-between mb-6">
              {weatherEntries}
            </div>
          </div>

        {/* Calendar */}
          <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-xl p-4 mb-6">

            {/* Month Navigation */}
            <div className="flex-none md:flex items-center justify-between">
              <div className="mb-4">
                <h2 className="text-3xl font-bold text-white">
                  {monthNames[currentDate.getMonth()]} {currentDate.getFullYear()}
                </h2>
              </div>
              <div className="flex gap-2">
                
                <button
                  onClick={prevMonth}
                className="px-6 py-3 bg-white/20 hover:bg-white/30 text-white rounded-xl transition-all font-semibold"
                >
                  ← Previous
                </button>

                {/* For desktop */}
                  <button
                  disabled={currentDate.getMonth() == today.getMonth()}
                  onClick={thisMonth}
                  className="hidden sm:inline px-6 py-3 bg-white/20 text-white text-sm rounded-xl transition-all font-semibold hover:bg-white/30 disabled:bg-white/10 disabled:text-white/10 "
                >
                  This Month
                </button>

                {/* For mobile */}
                {currentDate.getMonth() == today.getMonth() ? (
                  <button
                    onClick={jumpToToday}
                    className="sm:hidden px-6 py-3 bg-white/20 text-white text-sm rounded-xl transition-all font-semibold hover:bg-white/30 disabled:bg-white/10 disabled:text-white/10 "
                  >
                    Today ↓
                  </button>
                  ):
                (
                  <button
                    onClick={thisMonth}
                    className="sm:hidden px-6 py-3 bg-white/20 text-white text-sm rounded-xl transition-all font-semibold hover:bg-white/30 disabled:bg-white/10 disabled:text-white/10 "
                  >
                    This Month
                  </button>
                  )
                }

                <button
                  onClick={nextMonth}
                  className="px-6 py-3 bg-white/20 hover:bg-white/30 text-white rounded-xl transition-all font-semibold"
                >
                  Next →
                </button>
              </div>
            </div>

            <div className="grid grid-cols-7 gap-2 mb-4 hidden md:grid">
              {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                <div key={day} className="text-center font-bold text-white/90 py-2">
                  {day}
                </div>
              ))}
            </div>
            
            <div className="grid grid-cols-none md:grid-cols-7 gap-2">
              {calendarDays.map((day, index) => {
                if (!day) {
                  return <div key={`empty-${index}`} className="md:aspect-square"></div>;
                }
                
                return (
                  <div
                    key={day.date}
                    className="flex flex-col bg-white overflow-hidden rounded-xl p-2 pb-4 transition-all hover:shadow-lg relative min-h-[80px] md:min-h-[140px]"
                  >
                      <div className="flex justify-between relative mb-1 z-10">
                        <div id={(day.fullDate == today.toISOString().split('T')[0]) ? 'today' : 'false'} className={` text-lg md:text-sm font-bold ${(day.fullDate == today.toISOString().split('T')[0]) ? 'bg-red-500 text-white inline-flex items-center justify-center gap-1 rounded-full h-6 w-20 md:w-6' : 'bg-none text-gray-800'} `}>{day.date} <span className="inline md:hidden font-normal">{day.dayName}</span></div>
                        <button
                          onClick={() => openEntryModal(day.fullDate)}
                          className="bg-white/70 hover:bg-white rounded-full p-1 transition-all"
                          title="Add entry"
                        >
                          <Plus className="w-6 h-6 md:w-3 h-3 text-gray-700" />
                        </button>
                      </div>
                    

                    
                      {/* Entries */}
                      <div className="grow mt-2 space-y-1">
                        {day.entries.map(entry => (
                          <div
                            key={entry.id}
                            className={`${entry.entry_type == 'sowing_date' ? 'bg-slate-500 text-white' : 'bg-white/80 text-gray-800'} font-semibold rounded-sm px-2 py-2 md:py-1 text-sm md:text-[11px] group relative z-20`}
                          >

                            <div className=" truncate pr-8">
                              {entry.title}
                            </div>
                            <div className="absolute top-1 right-1 hidden group-hover:flex gap-1">
                              <button
                                onClick={() => handleEdit(entry, day.fullDate)}
                                className="bg-blue-500 hover:bg-blue-600 text-white rounded-sm p-0.5"
                              >
                                <Edit2 className="w-6 h-6 md:w-3 md:h-3" />
                              </button>
                              <button
                                onClick={() => handleDelete(entry.id)}
                                className="bg-red-500 hover:bg-red-600 text-white rounded-sm p-0.5 ml-2 md:ml-0"
                              >
                                <Trash2 className="w-6 h-6 md:w-3 md:h-3 " />
                              </button>
                            </div>
                          </div>
                        ))}
                      </div>

                      <div className="z-20">
                        <span className="text-sm">{day.zodiac.symbol}</span>                        
                        <span className="pl-1">{day.phaseIcon} {day.seasonIcon}</span>
                        <span className="text-xs">{ day.weatherData && day.weatherData.temperature + '°'}{ day.weatherData && day.weatherData.lowTemperature && '/' + day.weatherData.lowTemperature + '°'}</span>
                      </div>
                      
                      {getZodiacIndicator(day.zodiac)}
                      <div className={`${getZodiacColor(day.zodiac, false, false)} block absolute bottom-[-1%] left-0 right-0 h-3 z-0 rounded-b-xl`}></div>
                  </div>
                );
              })}
            </div>
        </div>
        {/* Legend */}
        <div className="bg-white/10 backdrop-blur-lg rounded-2xl shadow-xl p-6 mb-6">
          <h3 className="text-xl font-bold text-white mb-4">Moon in Zodiac Elements</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="flex items-center gap-2">
              <div className={`${getZodiacColor( {type: 'Fruit'}, false, false)}  w-6 h-6 rounded-sm`}></div>
              <span className="text-white">Fire - Fruit Days</span>
            </div>
            <div className="flex items-center gap-2">
              <div className={`${getZodiacColor( {type: 'Root'}, false, false)}  w-6 h-6 rounded-sm`}></div>
              <span className="text-white">Earth - Root Days</span>
            </div>
            <div className="flex items-center gap-2">
              <div className={`${getZodiacColor( {type: 'Flower'}, false, false)}  w-6 h-6 rounded-sm`}></div>
              <span className="text-white">Air - Flower Days</span>
            </div>
            <div className="flex items-center gap-2">
              <div className={`${getZodiacColor( {type: 'Leaf'}, false, false)}  w-6 h-6 rounded-sm`}></div>
              <span className="text-white">Water - Leaf Days</span>
            </div>
          </div>

          <h3 className="text-xl font-bold text-white mt-6 mb-4">Moon Phases</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="flex items-center gap-2">
              <img className="inline w-5 h-5 ml-1" src={moonIcons.wan_gib} /><span className="text-white"> Waning Gibbous - Root Plants</span>
            </div>
            <div className="flex items-center gap-2">
              <img className="inline w-5 h-5 ml-1" src={moonIcons.wan_cre} /><span className="text-white"> Waning Crescent - Barren Phase</span>
            </div>
            <div className="flex items-center gap-2">
              <img className="inline w-5 h-5 ml-1" src={moonIcons.wax_cre} /><span className="text-white"> Waxing Crescent - Leaf Plants</span>
            </div>
            <div className="flex items-center gap-2">
              <img className="inline w-5 h-5 ml-1" src={moonIcons.wax_gib} /><span className="text-white"> Waxing Gibbous - Fruit Plants</span>
            </div>
          </div>
          <h3 className="text-xl font-bold text-white mt-6 mb-0">Notes</h3>
          <ul className="list-disc list-inside text-white">
            <li>Transplant during Waning Gibbous, in respective zodiac </li>
            <li>Harvest Leaf plants on Flower/Fruit days</li>
            <li>Store Root plants on Root days</li>
          </ul>

        </div>
        
        {/* Entry Modal */}
        {showEntryModal && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-2xl font-bold text-gray-800">
                  {editingEntry ? 'Edit Entry' : 'Add Entry'}
                </h3>
                <button
                  onClick={closeEntryModal}
                  className="text-gray-500 hover:text-gray-700"
                >
                  <X className="w-6 h-6" />
                </button>
              </div>
              

              
              <form onSubmit={handleSubmit}>
              <div className="w-full mb-4 relative bg-slate-100">
                <input className="relative bg-transparent w-40 p-2 z-20" 
                  type="date" 
                  name="date" 
                  value={formData.date}
                  onChange={(e) => setFormData({ ...formData, date: e.target.value })}
                />                
              </div>
                <div className="mb-4">
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Entry Type
                  </label>
                  <select
                    value={formData.entry_type}
                    onChange={(e) => setFormData({ ...formData, entry_type: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                  >
                    <option disabled value="select" className="text-gray-200">Select Entry Type</option>
                    <option value="sowing_date">Sowing Date</option>
                    <option value="vegetable_note">Vegetable Note</option>
                    <option value="general_note">General Note</option>
                  </select>
                </div>


                {(formData.entry_type == 'sowing_date' || formData.entry_type == 'vegetable_note') &&
                  <div className="mb-4">
                    <SelectVegetables name="vegetableID" label="Select Vegetable" array={props.vegetables} editingEntry={editingEntry} filterHasCleared={null} handleChangeSelect={(e) => setFormData({ ...formData, vegetable_name: e.vegetable_name, vegetableID: [e.id] })}/>
                  </div>
                }

                {formData.entry_type != 'sowing_date' && formData.entry_type != 'select' &&
                    <div className="mb-4">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Title *
                      </label>
                      <input
                        type="text"
                        required
                        value={formData.title}
                        onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                        className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                        placeholder="e.g., Plant tomatoes"
                      />
                    </div>
                }

                {formData.entry_type != 'select' &&
                <>

                  <div className="mb-6">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Notes
                    </label>
                    <textarea
                      value={formData.description}
                      onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                      className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                      rows="3"
                      placeholder="Add notes about this activity..."
                    />
                  </div>
                  
                  <div className="flex gap-3">
                    <button
                      type="submit"
                      className="flex-1 bg-purple-600 hover:bg-purple-700 text-white font-semibold py-3 rounded-lg transition-all flex items-center justify-center gap-2"
                    >
                      <Save className="w-4 h-4" />
                      {editingEntry ? 'Update' : 'Save'}
                    </button>
                    <button
                      type="button"
                      onClick={closeEntryModal}
                      className="px-6 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-3 rounded-lg transition-all"
                    >
                      Cancel
                    </button>
                  </div>
                </>
              }
              </form>
            </div>
          </div>
        )}
        </>
      )}


  </>
  );
}
